<template>
  <div class="result-thumbnail-skeleton">
    <div class="loader">
      <v-skeleton-loader
        tile
        type="image"
        class="loader__image"
        height="140"
      />

      <v-skeleton-loader
        tile
        class="loader__body"
        type="image"
        height="140"
      />

      <v-skeleton-loader
        class="loader__subtitle"
        type="heading"
        height="50"
      />

      <v-skeleton-loader
        class="loader__title"
        type="heading"
        height="50"
      />

      <v-skeleton-loader
        class="loader__address"
        type="heading"
        height="50"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResultThumbnailSkeleton',
  }
</script>

<style lang="sass" scoped>

  .result-thumbnail-skeleton ::v-deep .loader
    position: relative
    height: 300px

    &__body
      height: 160px
      position: absolute !important
      width: 100%

    &__subtitle
      margin-top: 15px

    &__body .v-skeleton-loader__image
      background: rgba(0, 0, 0, 0.05) !important

    &__image .v-skeleton-loader__image
      background: rgba(0, 0, 0, 0.18) !important

    &__subtitle .v-skeleton-loader__heading
      margin: auto
      width: 15%
      height: 18px

    &__title .v-skeleton-loader__heading
      margin: auto
      width: 75%
      height: 24px

    &__address .v-skeleton-loader__heading
      margin: auto
      width: 90%
      height: 15px
</style>
